import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import {
  ContactForSelectFragment,
  ProjectManagementProjectStatusEnum,
} from 'generated/resources/graphql'

import { useFormContext } from 'modules/core/hooks/useForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ProjectBasicDetailsForm } from 'modules/project_management/components/forms/ProjectBasicDetailsForm'
import { ProjectStatusForm } from 'modules/project_management/components/forms/ProjectStatusForm'
import { StatusActions } from 'modules/project_management/lib/projectStatus'

import { CreateProjectProps } from '../types'

export const GeneralInformationStep = ({
  data,
  onDataChanged,
  clientReadOnly,
  companyId,
  hasClientsFeature,
}: WizardStepRenderParams<CreateProjectProps> & {
  clientReadOnly: boolean
  companyId: number
  hasClientsFeature: boolean
}) => {
  const form = useFormContext<CreateProjectProps>()

  const handleFieldChanged = (
    fieldName: string,
    fieldValue: string | ContactForSelectFragment | undefined | boolean
  ) => {
    onDataChanged({ ...data, [fieldName]: fieldValue })
  }

  const handleStatusChanged = (newStatus: ProjectManagementProjectStatusEnum) => {
    onDataChanged({ ...data, status: newStatus })
  }

  useOnNext(() => {
    track(trackingEvents.projectManagement.wizard.confirmBasicInformationProjectWizard, {
      code: data?.code,
      description: data?.description,
      start_date: data?.startDate,
      due_date: data?.dueDate,
      status: data?.status,
    })
  })

  return (
    <Box flexDirection="row" gap="s48">
      <Box flexDirection="column" gap="s24" width="s400">
        <Text.Header2 weight="semibold">
          {i18n.t('project_management.modals.create_project.wizard.step_one.header')}
        </Text.Header2>
        <Box flexDirection="column" gap="s16">
          <ProjectBasicDetailsForm
            values={data}
            errors={form.errors}
            onChangeValue={handleFieldChanged}
            companyId={companyId}
            hasClientsFeature={hasClientsFeature}
            clientReadOnly={clientReadOnly}
          />
          <ProjectStatusForm
            values={data}
            onChangeValue={handleStatusChanged}
            action={StatusActions.Create}
          />
        </Box>
      </Box>
    </Box>
  )
}
